<template>
  <div class="list" @click="$emit('select')">
    <div class="list__bookmark">
      <img
        @click.stop="$emit('deleteAddress')"
        v-if="address.isBookmark"
        src="@/assets/img/order/bookmark_on.svg"
      />
      <img
        v-else
        @click.stop="$emit('addBookmark')"
        src="@/assets/img/order/bookmark_off.svg"
      />
    </div>
    <div class="list__info">
      <div class="list__info--name">
        {{ address.name }} ({{ address.phoneNumber }})
      </div>
      <div class="list__info--address">
        {{ address.jibunAddress }} {{ address.detailAddress }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "addressResultList",
  data() {
    return {};
  },
  props: ["address"],
  methods: {},
};
</script>
<style scoped>
.list {
  display: flex;
  box-sizing: border-box;
  padding: 20px;
  gap: 20px;
  border-radius: 16px;
  background-color: var(--white);
  cursor: pointer;
}

.list__bookmark {
  display: flex;
  align-items: center;
}

.list__info {
  width: 100%;
  cursor: pointer;
}

.list__info--name {
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: var(--gray-700);
  word-break: break-all;
}

.list__info--address {
  word-break: break-all;
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  color: var(--gray-500);
}

.list:hover {
  background-color: var(--gray-100);
}

@media all and (min-width: 1024px) {
}
@media all and (max-width: 1023px) {
}
</style>
